<label class="money-input flex flex-col w-full">
  <span class="money-input__label block text-base font-medium mb-1 text-appText">
    {{ label }}
  </span>

  <span class="money-input__field relative block w-full">
    <span
      class="money-input__currency absolute top-1/2 -translate-y-1/2 right-3 text-appGrey text-lg pointer-events-none"
      aria-hidden="true"
    >
      ₪
    </span>
    <input
      [id]="inputId"
      type="text"
      [attr.inputmode]="decimals > 0 ? 'decimal' : 'numeric'"
      autocomplete="off"
      autocapitalize="off"
      spellcheck="false"
      [attr.aria-label]="label"
      [attr.aria-invalid]="error ? 'true' : null"
      [disabled]="disabled"
      [value]="displayValue"
      (input)="onInput($event)"
      (blur)="onBlur()"
      (keydown)="onKeydown($event)"
      (paste)="onPaste($event)"
      class="money-input__input w-full text-lg p-3 pr-9 border border-appGrey rounded-md bg-white text-appText min-h-[48px] focus:outline-2 focus:outline-offset-1 focus:outline-appBlue disabled:bg-gray-100 disabled:text-appGrey"
      [class.money-input__input--error]="error"
    />
  </span>

  <!-- Decimal mode: the amount as it will be saved, formatted. -->
  <span
    *ngIf="decimals > 0 && currentValue !== null && !error"
    class="block text-lg font-bold text-primary-700 mt-1 money"
    aria-live="polite"
  >
    {{ currentValue | currency : 'ILS' : 'symbol' : '1.2-2' }}
  </span>

  <!-- Decimal mode: why a key / paste was refused (never silent). -->
  <small
    *ngIf="decimals > 0 && rejectNotice && !error"
    class="block text-sm font-medium text-warning mt-1"
    role="status"
  >
    {{ rejectNotice }}
  </small>

  <small
    *ngIf="hint && !error"
    class="money-input__hint block text-xs text-appGrey mt-1"
  >
    {{ hint }}
  </small>
  <small
    *ngIf="error"
    class="money-input__error block text-sm text-red-700 mt-1"
    role="alert"
  >
    {{ error }}
  </small>
</label>
